import { render, staticRenderFns } from "./SummaryByAgent.vue?vue&type=template&id=40579055&scoped=true&"
import script from "./SummaryByAgent.vue?vue&type=script&lang=js&"
export * from "./SummaryByAgent.vue?vue&type=script&lang=js&"
import style0 from "./SummaryByAgent.vue?vue&type=style&index=0&id=40579055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40579055",
  null
  
)

export default component.exports